import * as React from 'react';

const SvgFormRadioDot = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" })
);

export { SvgFormRadioDot as default };
//# sourceMappingURL=FormRadioDot.es.js.map
